import * as React from 'react';
import { Dispatch } from 'react-redux';
import { MultiAppAuthenticationTitle } from '../../../components/MultiAppAuthentication/styles';
import { Translate } from 'react-redux-i18n';
import { StoreState } from '../../../reducers';
import { loadGallery } from '../../../containers/MultiAppAuthentication/actions';
import { PageOverlay } from '../../../components/PageOverlay/styles';
import Utils from '../../../utils';
import {
	StyledMultiAppAuthenticationPopup, CloseButton, AccessibleAppSelectWrapper,
	AccessibleAppSelect, AccessibleAppSelectIcon
} from '../../../components/MultiAppAuthentication/Popup/styles';
import { Api } from '../../../typings/api';
import { AuthenticateButton } from '../../Authentication/styles';
import { Server } from '../../../containers/MultiAppAuthentication/constants';
import { MultiAppAuthenticationInfosActionKeys } from '../../../containers/MultiAppAuthentication/actions';

export interface MultiAppAuthenticationPopupProps {
	isServerSelect: boolean;
	accessibleApps: Api.AspDriveResourceItem[];
	shouldSaveGalleryConfig: boolean;
	dispatch: Dispatch<StoreState>;
	onClose: () => void;
}

const availableServers = [
	Server.FR,
	Server.AR,
	Server.AU,
	Server.MIGRATIONV3
];

export class MultiAppAuthenticationPopup extends React.Component<MultiAppAuthenticationPopupProps, never> {

	private selectRef: HTMLSelectElement | null;

	constructor(props: MultiAppAuthenticationPopupProps) {
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
	}

	onSubmit(e: React.MouseEvent<HTMLButtonElement>): void {
		const { shouldSaveGalleryConfig, accessibleApps, isServerSelect } = this.props;
		if (this.selectRef) {
			if (isServerSelect) {
				const server = availableServers[this.selectRef.selectedIndex];
				this.props.dispatch({ type: MultiAppAuthenticationInfosActionKeys.UPDATE_SERVER, server: server });
				this.props.onClose();
			} else {
				const { clientId, globalId } = accessibleApps[this.selectRef.selectedIndex];
				this.props.dispatch(loadGallery(clientId, globalId, shouldSaveGalleryConfig));
			}
		}
	}

	render() {

		const { accessibleApps, isServerSelect } = this.props;
		const appOptions = accessibleApps.map((accessibleApp, index) =>
			<option value={accessibleApp.globalId} key={index}>{accessibleApp.genericItemName}</option>
		);
		const serverOptions = availableServers.map((server, index) =>
			<option value={server} key={index}>{server}</option>
		);

		return (
			<div>
				<PageOverlay isOpen={true} />
				<StyledMultiAppAuthenticationPopup>
					<CloseButton onClick={() => this.props.onClose()}>
						{Utils.getSvgIcon('iconset_close-2')}
					</CloseButton>
					<MultiAppAuthenticationTitle><Translate value={isServerSelect ? 'messages.select_server' : 'messages.select_application'} /></MultiAppAuthenticationTitle>
					<AccessibleAppSelectWrapper>
						<AccessibleAppSelect ref={ref => this.selectRef = ref}>
							{isServerSelect ? serverOptions : appOptions}
						</AccessibleAppSelect>
						<AccessibleAppSelectIcon>
							{Utils.getSvgIcon('iconset_down')}
						</AccessibleAppSelectIcon>
					</AccessibleAppSelectWrapper>
					<AuthenticateButton onClick={this.onSubmit}>
						<Translate value={isServerSelect ? 'messages.select_this_server' : 'messages.select_this_application'} />
					</AuthenticateButton>
				</StyledMultiAppAuthenticationPopup>
			</div>
		);
	}
}

export default MultiAppAuthenticationPopup;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/Popup/index.tsx